module.exports = __webpack_public_path__ + "media/images/poster-054d60e84cffee05f42540ad243733c1.png";